import { themes } from '@ui/constants';
import { useDomain } from './useDomain.hook';

export const useTheme = () => {
  const domain = useDomain();

  return {
    bgColor: themes[domain].bgColor,
    bgColorLight: themes[domain].bgColorLight,
    bgColorSecondaryLight: themes[domain].bgColorSecondaryLight,
    bgColorSecondary: themes[domain].bgColorSecondary,
    textColor: themes[domain].textColor,
    textColorDark: themes[domain].textColorDark,
    baseSelect: themes[domain].base.Select,
    baseAlert: themes[domain].base.Alert,
    baseButton: themes[domain].base.Button,
    baseProgress: themes[domain].base.Progress,
    invertedSelect: themes[domain].inverted.Select,
    chatPrimaryButton: themes[domain].chat.PrimaryButton,
    chatSecondaryButton: themes[domain].chat.SecondaryButton,
  };
};
